import React, { useEffect } from 'react';
import { getProductEntityName } from '../Product.config';

import { useAssignUserNeedDesignInput } from '../Product.hooks';
import {
  ProductDesignInput,
  BaseProductAssignDialogProps
} from '../Product.interface';
import AssignDesignInputDialog from './AssignDesignInputDialog';

export type UserNeedAssignDesignInputDialogProps = BaseProductAssignDialogProps<'userNeedId'>;

const UserNeedAssignDesignInputDialog: React.FC<UserNeedAssignDesignInputDialogProps> = (
  props: UserNeedAssignDesignInputDialogProps
) => {
  const {
    open,
    productId,
    userNeedId,
    selectedItems,
    onCancel,
    onError,
    onAssigned
  } = props;
  const {
    updatedProductUserNeed,
    isAssigning,
    error: assignError,
    assignDesignInputs
  } = useAssignUserNeedDesignInput(productId, userNeedId);

  // handle notification to parent after assigning
  useEffect(() => {
    if (updatedProductUserNeed) {
      onAssigned?.(updatedProductUserNeed);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedProductUserNeed]);

  useEffect(() => {
    if (assignError) {
      onError?.(assignError);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignError]);

  return (
    <AssignDesignInputDialog
      {...{ open, productId, selectedItems, onCancel, onError }}
      isLoading={isAssigning}
      contentText={`Search for ${getProductEntityName(
        'designInput'
      )} to assign to the ${getProductEntityName('userNeed')}.`}
      onSubmit={(designInputs: ProductDesignInput[]) => {
        assignDesignInputs({
          designInputIds: designInputs.map(
            (designInput: ProductDesignInput) => designInput.id
          )
        });
      }}
    />
  );
};

export default UserNeedAssignDesignInputDialog;
